import React from "react";
import type { ShopEntity } from "../../../../../../domain/types/company-shop";

interface PreviewStripBannerProps {
  shopEntityData: ShopEntity | null;
  stripBannerPreviewUrl: string | null;
}

export const PreviewStripBanner = ({
  shopEntityData,
  stripBannerPreviewUrl,
}: PreviewStripBannerProps) => {
  // 업로드 직후의 로컬 미리보기가 저장된 URL 보다 우선한다
  if (!(stripBannerPreviewUrl || shopEntityData?.stripBannerUrl)) {
    return null;
  }

  return (
    <section className="w-full flex justify-center bg-white">
      {shopEntityData?.stripBannerLink ? (
        <a
          href={shopEntityData.stripBannerLink}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full max-w-[1200px] mx-auto"
        >
          <img
            src={stripBannerPreviewUrl || shopEntityData.stripBannerUrl || ""}
            alt="띠배너"
            className="w-full max-h-[120px] h-auto object-cover block"
          />
        </a>
      ) : (
        <img
          src={stripBannerPreviewUrl || shopEntityData?.stripBannerUrl || ""}
          alt="띠배너"
          className="w-full max-w-[1200px] max-h-[120px] mx-auto h-auto object-cover block"
        />
      )}
    </section>
  );
};
